<div class="login" [ngClass]="{ landscape_login: tamWidth < 767 }">
  <div class="login__content">
    <div class="login__content__form">
      <img
        src="https://cdn.mango-soft.com/mango-core/mango-vertical.svg"
        alt="icon-mango"
        class="squared_logo"
      />
      <form
        class="login__content__form__container"
        [formGroup]="formLogin"
        (ngSubmit)="login()"
      >
        <div class="login__content__form__container__inputs">
          <div class="group">
            <label for="email">{{ translate.user }} </label>
            <div class="group__email">
              <input
                class="group__input"
                type="text"
                [placeholder]="translate.user || 'User'"
                formControlName="username"
                name="username"
                (keydown.enter)="keyPress()"
                aria-labelledby="username-label"
                (input)="validUser = 'pending'"
                autocomplete="off"
              />
              <mat-icon
                class="icon-arrow"
                (click)="validEmail()"
                *ngIf="validUser === 'pending' || validUser === 'invalid'"
                >arrow_forward</mat-icon
              >
              <div class="loader" *ngIf="validUser === 'loading'">
                <span class="loader-input"></span>
              </div>
            </div>
            <div *ngIf="getError('username')" class="error">
              <span class="text-error">
                {{ translate.userRequired || getError("username") }}
              </span>
            </div>
            <div *ngIf="validUser === 'invalid'" class="error">
              <span class="text-error">
                {{ translate.userNotFound }}
              </span>
            </div>
          </div>
          <div
            class="group buttonPassowrd"
            [ngClass]="{
              hiddenButton: validUser === 'valid' ? false : true
            }"
          >
            <label for="email">Password</label>
            <div class="group-password">
              <input
                [type]="isTypePassword"
                placeholder="***********"
                formControlName="password"
                class="group__input"
              />
              <mat-icon
                class="img-show-password"
                (click)="showPassword()"
                *ngIf="isTypePassword === 'password'"
                >visibility</mat-icon
              >
              <mat-icon
                class="img-show-password"
                (click)="showPassword()"
                *ngIf="isTypePassword === 'text'"
                >visibility_off</mat-icon
              >
            </div>

            <div *ngIf="getError('password')" class="error">
              <span class="text-error">
                {{ translate.password || getError("password") }}
              </span>
            </div>
          </div>
          <div class="login__content__form__container__forgot">
            <span
              class="login__content__form__container__forgot__text"
              (click)="forgotPassword()"
            >
              {{ translate.forgotPassword || "Forgot password?" }}
            </span>
          </div>
        </div>
        <div class="login__content__form__container__button">
          <button
            class="login__content__form__container__button__send"
            [disabled]="
              formLogin.invalid || invalidForm || validUser !== 'valid'
            "
            type="submit"
          >
            <span class="text-base font-lato" *ngIf="!loading">
              {{ translate.buttonLogin || "Login" }}
            </span>
            <div class="loader loader-btn" *ngIf="loading">
              <span class="loader-input"></span>
            </div>
          </button>
        </div>
        <div class="login__content__form__container__or">
          <div class="login__content__form__container__or__line"></div>
          <div>
            <span>{{ translate.or || "Login" }}</span>
          </div>
          <div class="login__content__form__container__or__line"></div>
        </div>
        <div class="login__content__form__container__button">
          <button
            class="login__content__form__container__button__send"
            type="button"
            *ngIf="!hiddenButtonPasskey"
            [disabled]="
              !formLogin.value.username || invalidForm || validUser !== 'valid'
            "
            (click)="authPasskeys()"
          >
            <span class="forgot-text" *ngIf="!loadingPasskeys">
              {{ translate.authPasseys || "Login with a passkey" }}
            </span>
            <div class="loader loader-btn" *ngIf="loadingPasskeys">
              <span class="loader-input"></span>
            </div>
          </button>
        </div>
        <div class="login__content__form__container__register">
          <span
            *ngIf="viewRedirectRegister"
            class="login__content__form__container__register__text"
            (click)="redirectRegister()"
          >
            {{
              translate.authRegister ||
                "Do not you have an account yet? sign up here."
            }}
          </span>
        </div>
      </form>
    </div>
    <div class="login__content__info">
      <img
        src="https://cdn.mango-soft.com/mango-core/powerby.svg"
        class="login__content__info__icon-powerby"
        alt=""
      />
      <span id="version" class="login__content__info__version">
        V.{{ dataLogin.version }}
      </span>
    </div>
  </div>
  <div class="landscape_logo"></div>
  <modal-auth
    [typeAuth]="typeAuth"
    class="modal-auth"
    [params]="params"
    (statusModal)="closeModalAuth($event)"
    *ngIf="typeAuth.statusModal"
  ></modal-auth>
  <forgot-password [statusModal]="isModalOpenForgotPassword"> </forgot-password>
  <lib-modal-not-passkey
    (close)="isOpenModalTwoAuth = false"
    *ngIf="isOpenModalTwoAuth"
  ></lib-modal-not-passkey>
</div>
